import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-devices',
    templateUrl: './devices.component.html',
    styleUrls: ['./devices.component.scss'],
    standalone: false
})
export class DevicesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
